/* pantallas-alumno (B): EL ICONO DE ADVERTENCIA DE UNA VENTANA (parte 2, "Ventanas").

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Cuando la ventana lo tiene hoy, el icono va en un cuadro de 48 px: naranja suave (#1C130D, icono
   #F27A2E) o rojo suave (#2A1414, icono #F87171). El icono mide 24. */
import React from 'react';

export const TONOS_DEL_ICONO_DE_VENTANA = Object.freeze({
  naranja: { fondo: '#1C130D', icono: '#F27A2E' },
  rojo: { fondo: '#2A1414', icono: '#F87171' },
});

export default function IconoDeVentana({ icono: Icono, tono = 'naranja', testid, className = '' }) {
  const c = TONOS_DEL_ICONO_DE_VENTANA[tono] || TONOS_DEL_ICONO_DE_VENTANA.naranja;
  return (
    <div aria-hidden="true" data-testid={testid} data-tono={tono} className={`w-12 h-12 shrink-0 rounded-xl flex items-center justify-center ${className}`.trim()} style={{ backgroundColor: c.fondo }}>
      {Icono ? <Icono className="w-6 h-6" style={{ color: c.icono }} /> : null}
    </div>
  );
}
